
import { addAPI, editAPI } from '../api'
import { defineComponent, reactive, ref, toRefs } from 'vue'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import { required, RangeLimit, letterAndNumber, xceptChinese, noBlank } from '@/utils/rules'
import { bankTypeOpt, isDefaultOpt } from '../config'
export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false
    },
    row: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: '新增车品牌'
    }
  },
  setup(props, { emit }) {
    const refFrom = ref<HTMLElement | any>(null)
    const state = reactive({
      bankTypeOpt,
      isDefaultOpt,
      visible: props.modelValue,
      formData: ref<any>({
      }),
      rules: {
        bankType: [required],
        appIdSecretKey: [required, xceptChinese, noBlank],
        appIdName: [required, RangeLimit(2, 16)],
        appId: [required, letterAndNumber, RangeLimit(6, 32)],
        isDefault: [required]
      }
    })

    if (props.title === '编辑') {
      state.formData = Object.assign({}, props.row)
    }

    /**
     * @description: 取消（关闭）当前 dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      emit('update:modelValue', false)
    }

    /**
     * @description: 表单提交
     * @param {*}
     * @return {*}
     */
    const onSubmit = async p => {
      let requestAPI = addAPI
      if (props.title === '编辑') requestAPI = editAPI

      const [err, res, msg] = await toResult(requestAPI(p))
      if (err) return
      console.log(res)
      ElMessage.success(msg || '成功')
      emit('update:list')
      onCancel()
    }

    /**
     * @description: 表单提交前校验
     * @param {*}
     * @return {*}
     */
    const onValidate = () => {
      console.log(refFrom.value)
      refFrom.value.validate((valid: boolean) => {
        if (!valid) return
        onSubmit({
          ...state.formData
        })
      })
    }

    return {
      ...toRefs(state),
      onCancel,
      onValidate,
      refFrom
    }
  }
})
